import { FC } from "react";

import { Col, List, PlusCircleOutlined, Popover, Space } from "@ctra/components";
import { Enterprise, useTranslation } from "@ctra/i18n";
import { isProduction } from "@ctra/utils";

import styles from "./ListItem.module.less";

/**
 * List item for the category list displayed on config search page
 * @param item
 * @returns
 */
export const ListItem: FC<{ item: { id: string; name: string }; onClick: () => void }> = ({
  item,
  onClick
}) => {
  const { t } = useTranslation();
  const {
    analytics: {
      config: {
        metric: { displayName }
      }
    }
  } = Enterprise;

  return (
    <List.Item onClick={onClick}>
      <Space className={styles.Item} wrap={false} size={"middle"}>
        <Col>
          {isProduction() ? (
            <PlusCircleOutlined className={styles.Icon} />
          ) : (
            <Popover content={item.id} trigger="hover">
              <PlusCircleOutlined className={styles.Icon} />
            </Popover>
          )}
        </Col>
        <Col>{t(displayName(item.name), { makeDefaultValue: true })}</Col>
      </Space>
    </List.Item>
  );
};
